function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#74DAFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0070DF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("rect", {
  id: "path-2",
  x: 0,
  y: 0,
  width: 64,
  height: 64,
  rx: 32
}), /*#__PURE__*/React.createElement("filter", {
  x: "-85.9%",
  y: "-54.7%",
  width: "271.9%",
  height: "271.9%",
  filterUnits: "objectBoundingBox",
  id: "filter-3"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 20,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.329350825 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "10.10\\u6700\\u7EC8",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5F00\\u53D1\\u8005\\u670D\\u52A1\\u5E73\\u53F0-10.14",
  transform: "translate(-1382.000000, -1311.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-16",
  transform: "translate(-92.000000, 1273.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-3",
  transform: "translate(457.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "dsi",
  transform: "translate(1047.000000, 48.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u77E9\\u5F62"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-3)",
  xlinkHref: "#path-2"
}), /*#__PURE__*/React.createElement("use", {
  fill: "url(#linearGradient-1)",
  fillRule: "evenodd",
  xlinkHref: "#path-2"
})), /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-7",
  transform: "translate(18.800000, 15.200000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.6960825,4.99240654 C27.4247423,4.83820093 20.7187629,0 14.1096907,0 C7.20989691,0 0.775257732,4.83820093 0.503917526,5.01168224 L0,5.32009346 L0.542680412,17.463785 L0.542680412,17.4830607 C0.794639175,20.8948598 2.17072165,22.9573598 3.48865979,24.7692757 C3.66309278,25.0198598 5.73690722,27.6799065 9.51628866,30.1279206 L14.1096907,33 L18.4123711,30.1086449 C21.5327835,28.0461449 23.5484536,26.0607477 24.4787629,25.0391355 C24.7501031,24.7307243 25.0020619,24.4223131 25.2346392,24.0753505 C26.3006186,22.4561916 27.4828866,20.8370327 27.6573196,17.4830607 L28.2,5.33936916 L27.6960825,4.99240654 L27.6960825,4.99240654 Z M25.7385567,15.8060748 C24.7501031,15.5940421 23.5096907,15.3820093 22.3080412,15.1507009 L21.2420619,14.9579439 L21.1451546,16.0373832 C20.9707216,17.791472 20.1373196,19.4106308 18.8387629,20.5864486 C17.5208247,21.7815421 15.8152577,22.4369159 14.0321649,22.4369159 C10.7179381,22.4561916 7.83010309,20.2009346 7.0742268,16.9818925 L5.13608247,17.4445093 C5.62061856,19.4106308 6.74474227,21.1454439 8.33402062,22.4176402 C9.96206186,23.6898364 11.9583505,24.3837617 14.0321649,24.3837617 C16.3191753,24.3837617 18.4898969,23.5356308 20.1954639,22.0128505 C21.5909278,20.7599299 22.56,19.1022196 22.9670103,17.271028 C23.8197938,17.4445093 24.8663918,17.598715 25.6610309,17.791472 C25.4672165,20.3358645 24.5175258,21.5309579 23.5872165,22.9380841 C23.4127835,23.2079439 23.2189691,23.4392523 23.0251546,23.6705607 C22.3468041,24.4415888 20.4086598,26.4077103 17.3463918,28.4123832 L14.1096907,30.5905374 L10.6210309,28.4123832 C7.13237113,26.1378505 5.17484536,23.6320093 5.13608247,23.6127336 L5.11670103,23.5934579 C4.08948454,22.2056075 2.75216495,20.4515187 2.53896907,17.3481308 L2.48082474,15.9988318 C4.53525773,15.5169393 4.98103093,15.4591121 6.18268041,15.1699766 L6.84164948,15.015771 L6.9385567,14.3603972 C7.42309278,10.8522196 10.4659794,8.2114486 14.0321649,8.2114486 C17.2494845,8.2114486 20.0985567,10.3703271 20.9319588,13.4351636 L22.8507216,12.8954439 C21.7653608,8.96320093 18.1410309,6.2260514 14.0321649,6.2260514 C11.803299,6.2260514 9.65195876,7.03563084 7.9657732,8.50058411 C6.49278351,9.79205607 5.46556701,11.5075935 5.0585567,13.4351636 C4.39958763,13.5893692 3.72123711,13.7050234 2.40329897,14.0134346 L2.05443299,6.45735981 C3.60494845,5.60922897 8.85731959,2.0239486 14.1096907,2.0239486 C19.148866,2.0239486 24.5562887,5.60922897 26.1649485,6.45735981 L25.7385567,15.8060748 Z",
  id: "\\u5F62\\u72B6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.0321649,10.3896028 C11.2218557,10.3896028 8.93484536,12.6641355 8.93484536,15.4591121 C8.93484536,18.2540888 11.2218557,20.5286215 14.0321649,20.5286215 C16.8424742,20.5286215 19.1294845,18.2540888 19.1294845,15.4591121 C19.1294845,12.6641355 16.8424742,10.3896028 14.0321649,10.3896028 Z M14.7686598,15.5940421 L14.7686598,17.4445093 C14.7686598,17.8492991 14.4391753,18.176986 14.0515464,18.176986 L14.0321649,18.176986 C13.6251546,18.176986 13.2956701,17.8492991 13.2956701,17.463785 L13.2956701,15.6133178 C12.8886598,15.3627336 12.636701,14.9193925 12.636701,14.4567757 C12.636701,13.6857477 13.2569072,13.0689252 14.0127835,13.0689252 C14.7686598,13.0689252 15.388866,13.6857477 15.388866,14.4375 C15.4082474,14.9001168 15.1562887,15.3434579 14.7686598,15.5940421 L14.7686598,15.5940421 Z",
  id: "\\u5F62\\u72B6"
})))))));

function SvgGroup15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "124px",
    height: "124px",
    viewBox: "0 0 124 124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5408\u4F5C\u9AD8\u6821") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup15);
export default __webpack_public_path__ + "static/media/group1_5.14b2f225.svg";
export { ForwardRef as ReactComponent };